// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","455":"4b24954f","977":"f71b7a63"}[chunkId] + ".chunk.js";
};